import axios from "axios";
import NProgress from "nprogress";
const API_URL = process.env.VUE_APP_APIADMINURL;

function shouldForceLogout(payload, statusCode) {
  const message = payload?.message;
  const errorCode = payload?.errors?.error_code;
  const responseStatus = payload?.errors?.status_code || statusCode;

  return (
    responseStatus === 401 &&
    (errorCode === 1020 || message === "Unauthorised user !")
  );
}

function forceLogout() {
  localStorage.removeItem("jwt_token");
  localStorage.removeItem("user");
  localStorage.removeItem("userVerifyData");
  localStorage.removeItem("tkutim");
  localStorage.removeItem("visitActvityProcess");
  localStorage.removeItem("lastActivityTime");
  localStorage.removeItem("vuex");

  delete axiosInstance.defaults.headers.common.Authorization;

  if (window.location.pathname !== "/login") {
    window.location.replace("/login");
  }
}

// create a new axios instance
const axiosInstance = axios.create({
  baseURL: API_URL,
});

// before a request is made start the nprogress
axiosInstance.interceptors.request.use((config) => {
  NProgress.start();
  return config;
});

// before a response is returned stop nprogress
axiosInstance.interceptors.response.use(
  (response) => {
    NProgress.done();

    if (shouldForceLogout(response?.data, response?.status)) {
      forceLogout();
      return Promise.reject(response);
    }

    return response;
  },
  (error) => {
    NProgress.done();

    const payload = error?.response?.data;
    const statusCode = error?.response?.status;
    if (shouldForceLogout(payload, statusCode)) {
      forceLogout();
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
